"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// `hashType' was relocated to the third argument.
var isDev = process.env.NODE_ENV === 'development';
var normalizeArgs = function (state, hashType) {
    if (typeof state === 'boolean') {
        isDev && console.warn('[icestark]: hashType was relocated to the third argument.');
        return [{}, hashType !== null && hashType !== void 0 ? hashType : state];
    }
    if (typeof state === 'object') {
        return [state, hashType];
    }
    return [{}, hashType];
};
exports.default = normalizeArgs;
